<template>
    <FlexClassWrapper
        :flex-direction="flexDirection.row"
        :justify-content="flexJustifyContent.flexStart"
        :flex-wrap="$mq | mq({ sm: flexWrap.wrap, pccFullSize: flexWrap.noWrap })"
    >
        <SpacingClassWrapper
            :padding-top="0"
            :padding-bottom="0"
        >
            <FormWrapperLayout :class="cardFormWrapperClasses">
                <FlexContainer
                    :flex-direction="flexDirection.row"
                    :flex-wrap="flexWrap.wrap"
                    :justify-content="$mq | mq({ sm: flexJustifyContent.spaceBetween, pccFullSize: flexJustifyContent.flexStart })"
                    :align-items="$mq | mq({ sm: flexAlignItems.flexEnd, pccFullSize: flexAlignItems.flexStart })"
                    :flex-basis="$mq | mq({ sm: 100, pccFullSize: 80 })"
                >
                    <SpacingClassWrapper
                        v-for="(fieldData, fieldName) in formFieldsData"
                        :key="fieldName"
                        :margin-bottom="$mq | mq({ sm: 8, md: 8, pccFullSize: 0 })"
                        :margin-right="$mq | mq({ sm: 0, pccFullSize: 4 })"
                        :margin-left="$mq | mq({ sm: 0, pccFullSize: 0 })"
                    >
                        <FormFieldContainer
                            :field-name="fieldName"
                            :field-attr="fieldData.attr"
                            :field-data="fieldData"
                            :field-value="fieldData.editableValue"
                            @value-change="setEditableFormValue"
                            @check-validity="setFormFieldValidity"
                        />
                    </SpacingClassWrapper>
                </FlexContainer>
                <SpacingClassWrapper :padding-top="$mq | mq({ sm: 0, pccFullSize: 6 })">
                    <FormButtonsContainer :in-progress="formLoadingStatus" @download-click="$emit('download-click')" />
                </SpacingClassWrapper>
            </FormWrapperLayout>
        </SpacingClassWrapper>
    </FlexClassWrapper>
</template>

<script>
// Class Wrappers
import FlexClassWrapper from '../../classWrappers/FlexClassWrapper';
import SpacingClassWrapper from '../../classWrappers/SpacingClassWrapper';

// Containers
import FlexContainer from '../../containers/flex/FlexContainer';
import FormFieldContainer from '../../containers/form/FormFieldContainer';
import FormButtonsContainer from '../../containers/form/FormButtonsContainer';

// Layouts
import FormWrapperLayout from './FormWrapperLayout';

// Mixins
import styles from '../../mixins/styles';

// Types
import {
    flexDirection,
    flexWrap,
    flexJustifyContent,
    flexAlignItems
} from '../../types/Flex.types';

// Vuex Store
import { createNamespacedHelpers } from 'vuex';
const { mapState, mapActions } = createNamespacedHelpers('pokerChipCalcModule');

export default {
    name: 'CardFormLayout',
    components: {
        // Class Wrappers
        FlexClassWrapper,
        SpacingClassWrapper,
        // Containers
        FlexContainer,
        FormFieldContainer,
        FormButtonsContainer,
        // Layouts
        FormWrapperLayout,
    },
    mixins: [styles],
    data: function () {
        return {
            flexDirection,
            flexWrap,
            flexJustifyContent,
            flexAlignItems
        }
    },
    computed: {
        ...mapState([
            'formFieldsData',
            'formLoadingStatus'
        ]),
        isMobile: function() { 
            return this.$mq === 'sm' || this.$mq === 'md'; 
        },
        cardFormWrapperClasses: function () {
            return [
                this.cssClasses.pcc__cardForm_wrapper
            ]
        },
        cardComponentClasses: function() {
            return [
                this.cssClasses[`pcc__cardComponent_${this.isMobile ? 'form-mobile' : 'form-desktop'}`],
            ]
        }
    },
    methods: {
        ...mapActions([
            'setEditableFormValue',
            'setFormFieldValidity'
        ]),
        getFormFieldRightMargin: function (formFieldIndex, cardRows) {
            const fieldsLength = Object.keys(this.formFieldsData).length;
            const fieldsPerRow = Math.ceil(fieldsLength/cardRows);
            const notLastInRow = (++formFieldIndex) % fieldsPerRow !== 0;
            return notLastInRow ? 7 : null;
        }
    }
}
</script>